import config from "@config"

export default async function createRouter() {
  const currentTemplate = config.template.name || "base"

  const routes = await import(`../${currentTemplate}/router/index.js`)

  return routes.default
}
